import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from '../string';
import { translatableValidator } from '../translatable';
export const screenValidator = Validator.object({
    id: nonEmptyStringValidator,
    name: translatableValidator
});
